import { Module } from 'vuex';
import UserService from '../services/user';
import MarketplaceService from '@/services/marketplace';
import { Cart } from '@/services/marketplace';

interface User {
  id: string;
}
interface RootState {
  companyData: any;
  loading: boolean;
  error: any;
}
interface UserState {
  user: User | null;
  cartItems: number;
  cartList: any[];
  myProducts: any;
}

const state: UserState = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  cartItems: 0,
  cartList: [],
  myProducts: 0,
};

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state,
  actions: {
    async me({ commit }) {
      try {
        const user = await UserService.me();
        commit('setUser', user);

        return user;
      } catch (error) {
        commit('meFailure');
        throw error;
      }
    },
    async getCartItems({ commit }) {
      try {
        const cart = await MarketplaceService.getCart();
        commit('setCartItems', cart);
        return cart;
      } catch (error) {
        throw error;
      }
    },
  },
  mutations: {
    setCartItems(state, items: any) {
      state.cartList = items.baskets;
      state.cartItems = items.baskets.reduce((acc: number, item: any) => acc + item.quantity, 0);
    },
    setMyProducts(state, products: number) {
      state.myProducts = products;
    },
    setUser(state, user: User) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    meFailure(state) {
      state.user = null;
    },
  },
};
